import { HttpError } from "@nestia/fetcher";
import api from "@api";
import { getConnection } from "@app/sdk";
import { config } from "@app/config/app";
import { PageOfGetCompanyDto } from "@api/structures/PageOfGetCompanyDto";

export interface Filters {
  pageSize?: number;
  page?: number;
}

const defaultResponse: PageOfGetCompanyDto = {
  rows: [],
  totalPages: 1,
};

const defaultFilters: Filters = {
  page: 1,
};

export const getAllCompanies = async (
  filters: Filters = {},
): Promise<PageOfGetCompanyDto> => {
  // Admin routes refuse an on-behalf request, so the list always runs in admin mode.
  const connection = getConnection();
  delete connection.headers?.[config.HEADERS.ACTIVE_COMPANY_ID];
  try {
    const response = await api.functional.admin.companies.getCompanies(
      connection,
      { ...defaultFilters, ...filters },
    );
    return (response.responseObject as PageOfGetCompanyDto) ?? defaultResponse;
  } catch (e) {
    if (e instanceof HttpError) {
      return defaultResponse;
    }
    throw e;
  }
};

export const isCompanyPrefixesAvailable = async (
  prefixes: string[],
): Promise<Record<string, boolean>> => {
  try {
    const response =
      await api.functional.admin.companies.prefix_available.isPrefixAvailable(
        getConnection(),
        prefixes.join(","),
      );
    return (response.responseObject as Record<string, boolean>) ?? {};
  } catch (e) {
    if (e instanceof HttpError) {
      return {};
    }
    throw e;
  }
};
